// #ux-redesign-start: UserDeleteForm migra SweetAlert → ConfirmDialog DS
import React, { useState } from 'react';
import { useTranslate } from 'react-translate';
import { useDispatch } from 'react-redux';
import { actionDeleteAccountRequest } from 'store/actions/usersActions';

import { Button, ConfirmDialog } from 'components/ds';

const UserDeleteForm = () => {
  const t = useTranslate('settings');
  const t2 = useTranslate('user-delete-form');
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const onConfirm = () => {
    dispatch(actionDeleteAccountRequest());
    setOpen(false);
  };

  return (
    <div className="setting-section account-deletion-section">
      <h5 className="general-card-subtitle">{t2('title')}</h5>
      {t2('save-data-notice')}
      <br />
      <Button
        variant="danger"
        name="btn-real-delete-user"
        onClick={() => setOpen(true)}
      >
        {t2('delete-account')}
      </Button>

      <ConfirmDialog
        isOpen={open}
        title="Sind Sie sicher?"
        description={t2('delete-account-disclaimer')}
        confirmLabel={t('btn-yes')}
        cancelLabel={t('btn-no')}
        variant="danger"
        onConfirm={onConfirm}
        onCancel={() => setOpen(false)}
      />
    </div>
  );
};

export default UserDeleteForm;
// #ux-redesign-end
